import { ErrorMessage } from "@hookform/error-message";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import calLogo from "../../assets/images/calender.svg";
import dummyImg from "../../assets/images/dummy.svg";
import chevRght from '../../assets/images/chev-right.svg'
import TopHeader from "../../components/layouts/TopHeader";
import Button from "../../components/ui/Button";
import { ApiConstants } from "../../constants/ApiConstants";
import ValidationMessage from "../../constants/ValidationMessage";
import authContext from "../../context/authContext";
import useMakeRequest from "../../utils/ApiHelper";
import { setDateHelper, getBudgetPeriodDates } from "../../utils/Helper";
import SelectMonthAndYearModalForOppertunityCost from "../contributions/SelectMonthAndYearModalForOppertunityCost";
import ProfileImage from "../../components/layouts/ProfileImage";
import PageLayout from "../../components/ui/PageLayout";

interface memberDetails {
  claimed_opportunity_hours: number
  final_value: number
  id: number
  name: string
  opportunity_cost_bonus: number
  total_chores_price: number
  total_hours: number
  maximum_opportunity_cost_hourse: number
  current_opportunity_hours: number
  isClaimed: boolean
  isEligiable: boolean
  profile_pic: string
}
interface contributionsInputs {
  start_date: string;
  end_date: string;
  total_completed_hours: number;
  average: number;
  members: memberDetails[];
  is_finalized: number | null;
  prevRate: string;
  prevHours: string;
  prevDesc: string;
  prevClaimedUsers: any[]
}

interface FormInputs {
  claim_hours: string;
  rate: string;
  description: string;
}

function OpportunityCost() {
  let profile: any = useContext(authContext);
  const claimOppertunityCost = useMakeRequest();
  const oppertunityCost = useMakeRequest();

  const [refetchData, setRefetchData] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [oppertunityCostItems, setOppertunityCostItems] = useState<contributionsInputs>(
    {
      start_date: "",
      end_date: "",
      total_completed_hours: 0,
      average: 0,
      members: [],
      is_finalized: null,
      prevRate: '0',
      prevHours: '0',
      prevDesc: "",
      prevClaimedUsers: []
    }
  );

  useEffect(() => {
    if (!oppertunityCostItems?.start_date && !oppertunityCostItems?.end_date) {
      // Calculate current month’s start date based on billingDate
      const { startDate, endDate } = getBudgetPeriodDates(
        moment().year(),
        moment().month(),
        profile?.data?.hh_member?.household?.billing_date || 1
      );

      // ✅ set state so UI shows dates
      setOppertunityCostItems({
        ...oppertunityCostItems,
        start_date: startDate,
        end_date: endDate,
      });

      // ✅ also set current month name
      setSelectedMonth(moment().format("MMMM"));

      oppertunityCost.makeRequest({
        url: ApiConstants?.OppertunityCostCheck,
        payload: {
          month: moment().month(),
          start_date: startDate,
          end_date: endDate,
        },
      })
    }
  }, []); // only run once at mount


  useEffect(() => {
    if (oppertunityCost?.status) {
      console.log("oppertunityCost?.data?.data?.total?.previousUserEnteredHours: ", oppertunityCost?.data?.data?.total)
      setOppertunityCostItems({
        start_date: oppertunityCost?.data?.data?.total?.start_date,
        end_date: oppertunityCost?.data?.data?.total?.end_date,
        total_completed_hours: oppertunityCost?.data?.data?.total?.total_completed_hours || 0,
        prevRate: oppertunityCost?.data?.data?.total?.previousClaimedRate || 0,
        prevHours: oppertunityCost?.data?.data?.total?.previousUserEnteredHours || 0,
        prevDesc: oppertunityCost?.data?.data?.total?.previousDescription || "",
        average: oppertunityCost?.data?.data?.total?.average || 0,
        members: oppertunityCost?.data?.data?.members || [],
        is_finalized: oppertunityCost?.data?.data?.total?.is_finalized,
        prevClaimedUsers: oppertunityCost?.data?.data?.total?.previousClaimsDetails
      })

    }

  }, [oppertunityCost?.status])


  const preveClaimedUsers = oppertunityCostItems?.prevClaimedUsers || []

  const filterderdClaimedMembers = oppertunityCostItems?.members?.filter(
    (item: memberDetails) => !item.isEligiable
  )
  // const filterderdClaimedMembers = currentUser?.isEligiable
  //   ? oppertunityCostItems?.members?.filter(
  //     (item: memberDetails) => item.id !== profile?.data?.id 
  //   )
  //   : oppertunityCostItems?.members;

  // const filterderdClaimedMembers = oppertunityCostItems?.members

  const { register, watch, setValue, formState: { errors }, handleSubmit, reset, trigger } = useForm<FormInputs>({
    mode: 'onChange',
    // resolver: yupResolver(OppertunityCostValidation),
  });

  const onSubmit = (form: FormInputs, maxOppHrs: any) => {
    console.log("form---> ", form)

    toast.promise(
      claimOppertunityCost.makeRequest({
        url: ApiConstants?.OppertunityCostClaimeHours,
        payload: {
          claim_hours: Number(form.claim_hours),
          rate: Number(form.rate),
          description: form.description,
          startDate: oppertunityCostItems.start_date,
          endDate: oppertunityCostItems.end_date,
          hh_id: profile?.data?.hh_member?.household?.id,
          maximum_opp_hour: maxOppHrs || 0
        },
        type: "POST"
      }),
      {
        loading: 'Saving...',
        success: (data: any) => data.message,
        error: (error: any) => error.message,
      }
    );
  };

  const fetchOpportunityCostData = (startDate?: string, endDate?: string) => {
    const start = startDate || oppertunityCostItems.start_date;
    const end = endDate || oppertunityCostItems.end_date;
    if (start && end) {
      oppertunityCost.makeRequest({
        url: ApiConstants?.OppertunityCostCheck,
        payload: {
          month: moment(start).month(),
          start_date: start,
          end_date: end,
        },
      });
    }
  };

  useEffect(() => {
    if (claimOppertunityCost.status) {
      fetchOpportunityCostData();
      claimOppertunityCost.reset();
    }
  }, [claimOppertunityCost.status]);

  useEffect(() => {
    console.log("oppertunityCostItems?.prevHours: ", oppertunityCostItems?.prevHours)
    setValue('claim_hours', oppertunityCostItems?.prevHours || '');
    setValue('rate', oppertunityCostItems?.prevRate || '');
    setValue('description', oppertunityCostItems?.prevDesc || '');
  }, [oppertunityCostItems])



  console.log("oppertunityCostItems: ", oppertunityCostItems)

  const endDate = new Date(oppertunityCostItems.end_date);
  const currentDate = new Date();

  // Set both dates to the start of the day for accurate comparison (optional)
  endDate.setHours(0, 0, 0, 0);
  currentDate.setHours(0, 0, 0, 0);

  return (
    <PageLayout headerName='Opportunity Costs' onlyTitle={false}>
      <div className="costs-page">
        {/* <TopHeader headerName="Opportunity Costs" /> */}
        <div>
          <div className="page-padding-x">
            <div className="col-12">
              <div className="com-input-grp">
                {/* <label className="form-label">Select Budget Period</label> */}
                <button
                  type="button"
                  onClick={() => {
                    const modal: any = $("#selectDateModalOppertunityCost");
                    modal.modal("show");
                  }}
                  className=" mb-2 date-modal-btn"
                >
                  {selectedMonth}
                  <img
                    className="up-down-arw"
                    src={chevRght}
                    alt=""
                  />
                </button>
              </div>
            </div>
            <div className="row mb-4 pt-3">
              <div className="col-6">
                <div className="com-input-grp disabled-input-grp">
                  <label className="form-label">Start Date</label>
                  <DatePicker
                    className="form-control"
                    placeholderText="MM/DD/YYYY"
                    timeFormat="MM DD YYYY"
                    onKeyDown={(e: any) => e.preventDefault()}
                    showYearDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={50}
                    disabled
                    selected={oppertunityCostItems?.start_date as any}
                    showIcon
                    icon={
                      <>
                        <img className="calIcon" src={calLogo} alt="" />
                      </>
                    }
                  />
                </div>
              </div>

              <div className="col-6">
                <div className="com-input-grp disabled-input-grp">
                  <label className="form-label">End Date</label>
                  <DatePicker
                    className="form-control"
                    placeholderText="MM/DD/YYYY"
                    timeFormat="MM DD YYYY"
                    onKeyDown={(e: any) => e.preventDefault()}
                    showYearDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={50}
                    disabled
                    selected={oppertunityCostItems?.end_date as any}
                    showIcon
                    icon={
                      <>
                        <img className="calIcon" src={calLogo} alt="" />
                      </>
                    }
                  />
                </div>
              </div>
              <div className="col-12">
                <div className='cost-info-box'>
                  <div className='info-row'>
                    <span className='info-label'>Total Chores Completed</span>
                    <span className='info-value'>{oppertunityCostItems.total_completed_hours} hrs</span>
                  </div>
                  <div className='info-row'>
                    <span className='info-label'>Average</span>
                    <span className='info-value'>{Number(oppertunityCostItems.average).toFixed(2)} hrs</span>
                  </div>
                </div>
              </div>

              {oppertunityCostItems?.members
                ?.filter((m) => m.isEligiable) // ✅ Only eligible members
                .map((member) => {
                  const isCurrentUser = member.id === profile?.data?.id;
                  const prev = preveClaimedUsers.find((p) => p.member_id === member.id);
                  return (
                    <div className="member-details-card" key={member.id}>
                      <div className="member-card-head">
                        {/* <img src={dummyImg} alt="" /> */}
                        <ProfileImage src={member?.profile_pic} size={25} />
                        <span className="member-card-name ms-2">{member.name}</span>
                      </div>

                      <div className="member-card-body">
                        <div className="row gy-2">
                          <div className="member-card-item-header">
                            <div className="member-card-item-label">Chores Completed</div>
                            <div className="member-card-item-value">{member.total_hours} hrs</div>
                          </div>
                          <div className="member-card-item-header">
                            <div className="member-card-item-label">Maximum Opportunity-Cost Hours</div>
                            <div className="member-card-item-value">{Number(member.maximum_opportunity_cost_hourse).toFixed(2)} hrs</div>
                          </div>
                          <div className="member-card-item-header">
                            <div className="member-card-item-label">Current Opportunity-cost Hours</div>
                            <div className="member-card-item-value">{Number(member?.current_opportunity_hours || 0).toFixed(2)} hrs</div>
                          </div>

                          {isCurrentUser ? (
                            // ✅ Editable Form for current user
                            <form
                              onSubmit={handleSubmit((form) => onSubmit(form, member.maximum_opportunity_cost_hourse))}
                              className="auth-form-wrap">
                              <div className="my-3 com-input-grp">
                                <label>Hours Claimed</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Hours"
                                  {...register("claim_hours", {
                                    required: ValidationMessage.CLAIMED_HOURS,
                                    // validate: (value) => {
                                    //   const maxHours = member?.maximum_opportunity_cost_hourse;
                                    //   const input = parseFloat(parseFloat(value).toFixed(2));
                                    //   const max = parseFloat(Number(maxHours).toFixed(2));
                                    //   if (value && input > max) {
                                    //     return `Cannot exceed ${max.toFixed(2)} hours.`;
                                    //   }
                                    //   return true;
                                    // },
                                  })}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  name="claim_hours"
                                  render={({ message }) => <p className="valid-error">{message}</p>}
                                />
                              </div>

                              <div className="mb-3 com-input-grp">
                                <label>Rate</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Rate"
                                  {...register("rate", { required: ValidationMessage.RATE })}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  name="rate"
                                  render={({ message }) => <p className="valid-error">{message}</p>}
                                />
                              </div>

                              <div className="mb-3 com-input-grp">
                                <label>Description</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Type here"
                                  {...register("description", { required: ValidationMessage.DESCRIPTION })}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  name="description"
                                  render={({ message }) => <p className="valid-error">{message}</p>}
                                />
                              </div>

                              <Button
                                className="com-btn"
                                type="submit"
                                loading={claimOppertunityCost?.loading}
                              >
                                Save
                              </Button>
                            </form>
                          ) : (
                            // ❌ Read-only view for other eligible members
                            <div className="auth-form-wrap mt-3">
                              <div className="mb-3 com-input-grp">
                                <label>Hours Claimed</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={prev?.previousClaimedHours ?? "0"}
                                  disabled
                                />
                              </div>

                              <div className="mb-3 com-input-grp">
                                <label>Rate</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={prev?.previousClaimedRate ?? "0"}
                                  disabled
                                />
                              </div>

                              <div className="mb-3 com-input-grp">
                                <label>Description</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={prev?.previousDescription ?? ""}
                                  disabled
                                />
                              </div>
                            </div>
                          )}

                        </div>
                      </div>
                    </div>
                  );
                })}

              {filterderdClaimedMembers?.length > 0 && filterderdClaimedMembers.map((member: memberDetails) => (
                <div className="member-details-card" key={member.id}>
                  <div className="member-card-head">
                    {/* <img src={dummyImg} alt="" /> */}
                    <ProfileImage src={member?.profile_pic} size={25} />
                    <span className="member-card-name ms-2">{member.name}</span>
                  </div>
                  <div className="member-card-body">
                    <div className="row gy-2">
                      <div className="member-card-item-header">
                        <div className="member-card-item-label">Chores Completed</div>
                        <div className="member-card-item-value">{member.total_hours} hrs</div>
                      </div>
                      <div className="member-card-item-header">
                        <div className="member-card-item-label">Maximum Opportunity-Cost Hours</div>
                        <div className="member-card-item-value">{Number(member.maximum_opportunity_cost_hourse).toFixed(2)} hrs</div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              {/* <div className="member-details-card">
              <div className="member-card-head">
                <img src={dummyImg} alt="" />
                <span>Member Name</span>
              </div>
              <div className="member-card-body">
                <div className="row gy-2">
                  <div>
                    <div>Hours of Chores</div>
                    <div>22</div>
                  </div>
                  <div>
                    <div>Maximum Opportunity-Cost Hours</div>
                    <div>0</div>
                  </div>
                </div>
              </div>
            </div> */}

            </div>
          </div>
        </div>
        <SelectMonthAndYearModalForOppertunityCost
          billingDate={profile?.data?.hh_member?.household?.billing_date}
          refetchData={refetchData}
          onContinue={(e: any) => {
            setOppertunityCostItems(e);
            // contributions.reset();
            // setIsFinalized(false);
            // setSelectedDivisionType("equal_split");
          }}
          selectMonth={setSelectedMonth}
        />
        {/* <SelectMonthAndYearModal
        billingDate={profile?.data?.hh_member?.household?.billing_date}
        onContinue={(e: any) => {
          setoppertunityCostItems(e);
          // contributions.reset();
          // setIsFinalized(false);
          // setSelectedDivisionType("equal_split");
        }}
        selectMonth={setSelectedMonth}
      /> */}
      </div>
    </PageLayout>
  );
}

export default OpportunityCost;
